// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__yjnAm","dashboardEmail":"Dashboard_dashboardEmail__2FAOs","dashboardContent":"Dashboard_dashboardContent__xYE9W"};